export enum RequirementsViewModes {
  Advanced = 'Advanced',
  Basic = 'Basic',
  Custom = 'Custom',
}
